__turbopack_context__.v({
  "blogCard": "T1id3a_blogCard",
  "blogCardContent": "T1id3a_blogCardContent",
  "blogCardHeader": "T1id3a_blogCardHeader",
  "blogCardImage": "T1id3a_blogCardImage",
  "blogCardInner": "T1id3a_blogCardInner",
  "readMoreLink": "T1id3a_readMoreLink",
  "readMoreText": "T1id3a_readMoreText",
});
